import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./style.scss";

const CinemaHeroCarousel = ({ items = [] }) => {
  const navigate = useNavigate();
  
  return (
    <div className="hero-carousel">
      <Swiper
        modules={[Autoplay]}
        loop
        autoplay={{ delay: 3500, pauseOnMouseEnter: true }}
        speed={900}
        spaceBetween={16}
        breakpoints={{
          0: { slidesPerView: 2 },
          768: { slidesPerView: 3.2 },
          1024: { slidesPerView: 4 },
        }}
      >
        {items.map((item, idx) => (
          <SwiperSlide key={idx}>
            <div
              className="hero-card"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/chi-tiet/${item.path}`);
              }}
            >
              {/* THUMB 3:4 */}
              <div className="hero-card__thumb-wrap">
                <img
                  // Đã xóa proxy image.php - Trả về link gốc trực tiếp
                  src={item.thumb || item.image}
                  alt={item.title}
                  loading="lazy"
                  className="hero-card__thumb"
                />
              </div>

              {/* POSTER 2:3 ĐÈ */}
              <img
                // Đã xóa proxy image.php - Trả về link gốc trực tiếp
                src={item.poster || item.image}
                alt={item.title}
                loading="lazy"
                className="hero-card__poster"
              />

              {/* TITLE */}
              <div className="hero-card__detail">
                <h6 className="film-card__title2">{item.title}</h6>
                <p className="film-card__episode2">
                  {item.time || item.episode_current}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CinemaHeroCarousel;